import { IDocumentTable } from '@models/Document.model';
import { T_TYPOGRAPHY_FLAT } from '@styles/fonts/fontsizes/typography-flat';

import { T_COLOR_SHADES } from '@styles/colors/themes/beam/beam-flat';
import { DIALOG_OPEN_DELAY } from '@components/TagDialog/TagDialog.utils';
import { TooltipInternal } from '@components/TooltipInternal/TooltipInternal';
import { QueryClient } from 'react-query';
import { CellText } from '../components/CellText';
import {
  CellAnchorText,
  StyledCell,
  CellGroupAddedBy,
} from '../components/DocumentsBody/DocumentsBody.styles';
import { IHeader } from '../components/DocumentsBody/DocumentsBody.types';
import { DocumentTooltipContent } from '../components/DocumentTooltipContent/DocumentTooltipContent';
import { getAddedByIcon } from './getAddedByIcon';
import { getAssociatedWithNameColor } from './getAssociatedWithNameColor';
import { getDocumentValue } from './getDocumentValue';
import { EditDocumentMenu } from '../components/EditDocumentMenu';
import { SourceLabel } from './SourceLabel';

interface GetDocumentCellParams {
  heading: IHeader;
  document: IDocumentTable;
  isLast: boolean;
  queryClient: QueryClient;
}

export function getDocumentCell(params: GetDocumentCellParams) {
  const { heading, document, isLast, queryClient } = params;
  const value = getDocumentValue(heading.fieldName, document);
  const text: keyof T_TYPOGRAPHY_FLAT = 'p200';
  let textColor: T_COLOR_SHADES = 'n900';
  let content = <></>;
  let after = <></>;

  if (heading.fieldName === 'associatedWithName') {
    textColor = getAssociatedWithNameColor(document);
  }
  if (value) {
    content = <CellText textColor={textColor}>{value}</CellText>;
  }
  if (heading.fieldName === 'associatedWithSource') {
    content = (
      <SourceLabel
        addedBy={document.addedBy}
        value={value}
        defaultColor={textColor}
      />
    );
  }
  if (heading.fieldName === 'label') {
    content = (
      <TooltipInternal
        color="white"
        label={
          <DocumentTooltipContent
            description={document.description}
            value={value}
          />
        }
        withArrow
        arrowSize={12}
        arrowOffset={19}
        position="top-start"
        // opened={document.id === '4354c722-42ee-4fbd-98c9-f4fbca1f056a'}
        openDelay={DIALOG_OPEN_DELAY}
      >
        <CellAnchorText text={text} href={document.uri || '#'}>
          {value}
        </CellAnchorText>
      </TooltipInternal>
    );
  }
  if (heading.fieldName === 'addedByName') {
    const iconJsx = getAddedByIcon(document);
    content = (
      <CellGroupAddedBy>
        {iconJsx}
        <CellText>{value}</CellText>
      </CellGroupAddedBy>
    );
  }
  if (!value) {
    content = (
      <CellText textColor="n600" italic>
        Empty
      </CellText>
    );
  }
  if (isLast) {
    after = (
      <EditDocumentMenu
        document={document}
        invalidate={() => {
          queryClient.invalidateQueries(['documents', 'page']);
        }}
      />
    );
  }

  return (
    <StyledCell className="new-icon">
      {content}
      {after}
    </StyledCell>
  );
}
